<div class="button" (click)="showInformation()">
  information <mat-icon>info</mat-icon>
</div>
<div class="data" *ngIf="show">
  <mat-list class="list-with-columns">
    <mat-list-item>
      <mat-icon mat-list-avatar>created</mat-icon>
      <h3 mat-line>Created at</h3>
      <div mat-line>{{ data.created_at | date : "mediumDate" }}</div>
      <div>{{ data.created_at | date : "mediumTime" }}</div>
      <h2 mat-line>By : {{ createUser?.name || "-" }}</h2>
    </mat-list-item>
    <mat-list-item>
      <mat-icon mat-list-avatar>updated</mat-icon>
      <h3 mat-line>Updated at</h3>
      <div mat-line>
        {{ (data.updated_at | date : "mediumDate") || "-" }}
      </div>
      <h2 mat-line>By : {{ updateUser?.name || "-" }}</h2>
      <div>{{ data.updated_at | date : "mediumTime" }}</div>
    </mat-list-item>
  </mat-list>
</div>
